export default __webpack_public_path__ + "images/0x00fbac94fec8d4089d3fe979f39454f48c71a65d.png";